import lazyPage from "../../../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/components/Task/types/Embed/editor/embededitor.tsx",
    () => import("./embededitor"),
);
